import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ExternalCreditCardRequest,
  ExternalCreditCardResponse,
} from '../models/external-credit-card.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalCreditCardService {
  private readonly API_URL = '/external/payments';
  private apiService = inject(ApiService);


  createCreditCard(
    payload: ExternalCreditCardRequest
  ): Observable<ExternalCreditCardResponse> {
    return this.apiService.post<ExternalCreditCardResponse>(
      `${this.API_URL}/credit-card`,
      payload
    );
  }

  updateCreditCard(
    payload: ExternalCreditCardRequest
  ): Observable<any> { 
    return this.apiService.put<any>( 
      `${this.API_URL}/update-credit-card`,
      payload, { responseType: 'text' as 'json' } 
  );
  }
}
